/**
 * ч.1125: доступ до панелі платформи — хто його має, видача й відкликання.
 * Лише власник платформи з входом, підтвердженим кодом; кожна зміна — з паролем.
 */
import { api } from './client';

export type PlatformAccessLevel = 'OWNER' | 'SUPPORT' | 'VIDEO';

export interface PlatformAccessUser {
  id: string;
  email: string;
  full_name: string;
  is_active: boolean;
  level: PlatformAccessLevel;
  also_support: boolean;
  /** ч.1319: власник / співробітник підтримки, що ще й редагує відео-інструкції. */
  also_video?: boolean;
  two_factor: boolean;
  last_login_at: string | null;
  /** Головний власник: пошта задана в налаштуваннях сервера — забрати не можна. */
  is_root: boolean;
  is_me: boolean;
}

export interface PlatformAccessLogRow {
  created_at: string;
  action: 'GRANT' | 'REVOKE';
  level: PlatformAccessLevel;
  target_email: string;
  performed_by_email: string;
}

export interface PlatformAccessOverview {
  /** Чи може поточний власник видавати й забирати рівень «власник платформи». */
  can_manage_owners: boolean;
  items: PlatformAccessUser[];
  log: PlatformAccessLogRow[];
}

const SILENT = { headers: { 'X-Silent-Toast': '1' } };

export const platformAccess = {
  overview: () => api.get<PlatformAccessOverview>('/platform/access').then((r) => r.data),
  grant: (email: string, level: PlatformAccessLevel, password: string) =>
    api.post('/platform/access/grant', { email, level, password }, SILENT).then((r) => r.data),
  revoke: (userId: string, level: PlatformAccessLevel, password: string) =>
    api.post('/platform/access/revoke', { user_id: userId, level, password }, SILENT).then((r) => r.data),
};
